<template>
    <span class="MetricIndicator">
        <div :style="`width: ${value * 100}%; background-color: ${getColor(value)}`"></div>
    </span>
</template>

<script>
import colourService from '@/services/colour-service';

export default {
    props: {
        value: {
            type: Number,
            required: true
        }
    },
    methods: {
        getColor () {
            if (this.value > 0.7) {
                return colourService.getIndicatorColours.green;
            }
            if (this.value > 0.3) {
                return colourService.getIndicatorColours.orange;
            }
            return colourService.getIndicatorColours.red;
        }
    }
};
</script>

<style lang="scss" scoped>
    .MetricIndicator {
        width: 18px;
        height: 6px;
        margin-top: 9px;
        background-color: $panel-background;
        border: 1px solid $grey-dark;
        position: relative;
        float: right;
        margin-left: 4px;

        div {
            position: absolute;
            height: 100%;
            left: 0;
        }
    }

</style>
